module.exports = __webpack_public_path__ + "img/mouth-sel.07923a48.svg";